import { makeStyles } from 'tss-react/mui';

import { MOBILE_BREAK_POINT } from 'app/constants';

export default makeStyles({ name: 'Home' })((theme) => ({
    title: {
        maxWidth: 1065,
        margin: '80px auto 160px auto',
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            margin: '16px auto 96px auto'
        }
    },
    section: {
        marginBottom: 160,
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            marginBottom: 96
        }
    }
}));
